<template>
  <div>  
    <b-navbar
      v-if="computedScreenWidth"
      toggleable="lg" 
      type="dark" 
      class="navbar"
    >
      <b-navbar-brand @click="redirect('/')">
        <img src="@/assets/picz_logo_white_mobile.svg" height="60" alt="Logo">
      </b-navbar-brand>
      <b-nav  class="ml-auto" align="right" style="margin-top:40px;">
        <b-nav-item @click="redirect('login')"><p style="color:whitesmoke;">Login</p></b-nav-item>
        <b-nav-item @click="redirect('register')"><p style="color:whitesmoke;">Register</p></b-nav-item>            
      </b-nav>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" style="margin-top:40px;background-color:rgb(5,47,102,0.80)" is-nav>
        <b-navbar-nav>          
          <b-form-group style="padding-top:10px;padding-right:20px;padding-bottom:30px;height:30px;color:transparent" @submit.stop.prevent>
            <v-text-field
              placeholder="Search ..."                        
              v-model="searchText"                    
              dense    
              outlined
              dark
              style="padding-right:5px;color:lightgray;"
            >  
            </v-text-field>            
          </b-form-group>          
          <v-menu 
            offset-y 
            :position-x="x"
            :position-y="y"
            open-on-hover
            absolute    
            origin="top bottom"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <b-nav-item
                href="#"                 
                v-on="on"                       
              >
                <h6 style="color:whitesmoke">Individual</h6>
              </b-nav-item>
            </template>
            <IndividualMenuMobile />
          </v-menu>
          <v-menu 
            offset-y 
            :position-x="x"
            :position-y="y+45"
            open-on-hover
            absolute    
            origin="top bottom"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <b-nav-item 
                href="#"
                v-on="on"
              >
                <h6 style="color:whitesmoke">Corporate</h6>
              </b-nav-item>
            </template>
            <CorporateMenuMobile />
          </v-menu>
          <b-nav-item href="#" @click="redirect('about')"><h6 style="color:whitesmoke">About Us</h6></b-nav-item>
          <b-nav-item href="#" @click="redirect('contact')"><h6 style="color:whitesmoke">Contact</h6></b-nav-item>
        </b-navbar-nav>    
      </b-collapse>
    </b-navbar> 
    <b-navbar
      v-else
      toggleable="lg" 
      type="dark" 
      class="navbar"
    >
      <b-navbar-brand @click="redirect('/')">
        <img src="@/assets/picz_logo_white_small.svg" height="80" alt="Logo">
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" style="margin-top:40px" is-nav>
        <b-navbar-nav>
          <b-nav-item href="#" @click="redirect('/')"><h6 style="color:whitesmoke">Home</h6></b-nav-item>
          <v-menu 
            offset-y 
            :position-x="z"
            :position-y="w"
            open-on-hover
            absolute    
            origin="top bottom"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <b-nav-item
                href="#"                 
                v-on="on"                       
              >
                <h6 style="color:whitesmoke">Individual</h6>
              </b-nav-item>
            </template>
            <IndividualMenu />
          </v-menu>
          <v-menu 
            offset-y 
            :position-x="w"
            :position-y="z+30"
            open-on-hover
            absolute    
            origin="top bottom"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on }">
              <b-nav-item 
                href="#"
                v-on="on"
              >
                <h6 style="color:whitesmoke">Corporate</h6>
              </b-nav-item>
            </template>
            <CorporateMenu />
          </v-menu>
          <b-nav-item href="#" @click="redirect('about')"><h6 style="color:whitesmoke">About Us</h6></b-nav-item>
          <b-nav-item href="#" @click="redirect('contact')"><h6 style="color:whitesmoke">Contact</h6></b-nav-item>
        </b-navbar-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown lazy right no-caret>
            <b-dropdown-form style="width: 600px;">
              <b-form-group @submit.stop.prevent>
                <b-form-input
                  id="dropdown-form-email"
                  size="sm"
                  placeholder="Type your Search text here and hit Enter..."
                >
                </b-form-input>
              </b-form-group>
            </b-dropdown-form>
            <template v-slot:button-content>
              &#x1f50d;<span class="sr-only">Search</span>
            </template>
          </b-nav-item-dropdown>
          <template v-if="user.loggedIn">
            <v-btn 
              icon
              @click="$modal.show('services-modal')"
              dark
            >
              <v-icon title="My Account">mdi-apps</v-icon>
            </v-btn>
            <v-btn 
              icon
              @click="$modal.show('user-profile-modal')"
              dark
            >
              <v-icon>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <b-nav-item @click="redirect('login')"><h6 style="color:whitesmoke">Login</h6></b-nav-item>
            <b-nav-item @click="redirect('register')"><h6 style="color:whitesmoke">Register</h6></b-nav-item>    
          </template>        
        </b-navbar-nav>          
      </b-collapse>
    </b-navbar>  
    <UserProfileModal />
    <ServicesModal />     
  </div>
</template>
<script>
  import 'bootstrap/dist/css/bootstrap.css';
  import 'bootstrap-vue/dist/bootstrap-vue.css';
  import IndividualMenu from '@/components/IndividualMenu.vue';
  import CorporateMenu from '@/components/CorporateMenu.vue';
  import IndividualMenuMobile from '@/components/IndividualMenuMobile.vue';
  import CorporateMenuMobile from '@/components/CorporateMenuMobile.vue';
  import UserProfileModal from '@/components/modals/UserProfileModal.vue';
  import ServicesModal from '@/components/modals/ServicesModal.vue';
  import { mapGetters } from 'vuex';
  import VueScreenSize from 'vue-screen-size';

  export default {
    name: "NavBar-3",
    components: {
      IndividualMenu,
      CorporateMenu,
      IndividualMenuMobile,
      CorporateMenuMobile,
      UserProfileModal,
      ServicesModal
    },
    mixins: [
      VueScreenSize.VueScreenSizeMixin
    ],
    data() {
      return {
        x:40,
        y:230,
        w:80,
        z:185,
        searchText: ''
      }
    },
    methods: {
      redirect(path){
        this.$router.push(path);
      },
      handleScroll(){
				if(window.scrollY > 500) {
          document.getElementsByClassName('navbar')[0].classList.add('solid');
				} else {
          document.getElementsByClassName('navbar')[0].classList.remove('solid');
				}
      },
    },
    computed: {
    // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        user: "user"
      }),
      computedScreenWidth () {
        var go_mobile = false;
        if (this.$vssWidth < 600){
          go_mobile = true;
        }
        return go_mobile;
      },
    },
    created() {
      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    }
 }
</script>
<style scoped>
  .navbar {
    height: 100px;
    width: 100%;
    background-color:rgb(5,47,102,0.80);
    border: none;
    color: white;    
    position: fixed;
    z-index: 100;
    padding-left: 10px;
    padding-right: 10px;    
  }
  @media only screen and (min-width: 600px) {
    .navbar {
      height: 100px;
      width: 100%;
      background-color:rgb(5,47,102,0.80);
      border: none;
      color: white;    
      position: fixed;
      z-index: 100;
      padding-left: 100px;
      padding-right: 100px;    
    }
  }  
</style>
